"use strict";
var round = Math.round;
module.exports = function(it) {
  var value = round(it);
  return value < 0 ? 0 : value > 255 ? 255 : value & 255;
};
